/* eslint-disable camelcase */
import React from "react";
import { List } from "semantic-ui-react";
import graphql from "babel-plugin-relay/macro";
import { createFragmentContainer } from "react-relay";

function IngredientsSummaryList({ summaryIngredient: { edges } }) {
  return (
    <List verticalAlign="middle">
      {edges &&
        edges?.map((ingredient, i) => {
          return (
            <List.Item key={i}>
              <List.Content>
                <List.Item>{ingredient.node.ingredient.name}</List.Item>
              </List.Content>
            </List.Item>
          );
        })}
    </List>
  );
}

export default createFragmentContainer(IngredientsSummaryList, {
  summaryIngredient: graphql`
    fragment IngredientsSummaryList_summaryIngredient on RecipeIngredientNodeConnection {
      edges {
        node {
          ingredient {
            name
          }
        }
      }
    }
  `,
});
